import React from "react";
import Typical from "react-typical";


const Home = () => {
  return (
    <div className="home">
      <div className="row mt-lg-5 justify-content-center">
        <div className="col-10 mt-5">
          <div className="myfont_p">My name is Pawel aka Pavo.</div>
          <div className="display-4 myfont">
            I build stuff for
            <Typical
              steps={[
                "Wix.",
                2000,
                "Wordpress.",
                2000,
                "Squarespace.",
                2000,
                "You.",
                2000,
                "the web.",
              ]}
              loop={1}
              wrapper="div"
            />
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 mt-5">
          <div className="myfont_p">
          If you have an idea for a feature or functionality for your website, but you don't know how to do it...
          </div>
          <div className="display-4 myfont" style={{color:"orange"}}>I can help!</div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-10 mt-5">
          <div className="col-lg-7 myfont_p">
            I specialize in creating (and occasionally designing) exceptional
            website components. Currently, I'm focused on helping individuals
            with CMS-based websites such as
            <a
              href="https://www.wix.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              WIX
            </a>
            ,
            <a
              href="https://wordpress.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              Wordpress
            </a>
            ,
            <a
              href="https://www.squarespace.com/"
              rel="noopener noreferrer"
              target="_blank"
            >
              {" "}
              Squarespace
            </a>
            , etc; implement cool custom features which may require more code knowledge.
            
          </div>

        </div>
      </div>
      <div className="row justify-content-center pb-5">
        <div className="col-10 mt-4 myfont_p fs-4">
          "Just because you are doing a lot more doesn't mean you are getting a lot done. Don't confuse movement with progress!"
          <div className="myfont_p fst-italic text-end" >― <small>Denzel Washington</small></div>
        </div>
      </div>
    </div>
  );
};

export default Home;
